import React from 'react'

const EmptyState = ({from,clickedFunction,firstText,secondText,buttonText,search}) => {
  return (
    
    <div className='oval-container'>
        <div class="oval4-u">
          <div class="oval3-u">
              <div class="oval2-u">
                  <div class="oval1-u">
                      <h2 class="oval-h2">{search ? 'No Results' : firstText}</h2>
                      <p class="oval-para">{search ? 
                      <>No campaigns found for “{search}”.<br/>Try using a different keyword.</> : 
                      secondText}</p>
                      {
                        !search && buttonText &&
                        <button class="project-blue-btn" onClick={clickedFunction}>{buttonText}</button>
                      }
                  </div>
              </div>
          </div>
      </div>
    </div>
  )
};

export default EmptyState;